export default __webpack_public_path__ + "static/media/blockman-icon.92b966fc.png";